/**
 * Created to use in multiply operation between numbers with decimal places.
 */
const multiply = (a: number, b: number, decimalPlaces?: number): number => {
	const multiplier = 10 ** (decimalPlaces || 0);
	const result = a * multiplier * (b * multiplier);
	return result / (multiplier * multiplier);
};

export default multiply;
